import { render, staticRenderFns } from "./MyVCards.vue?vue&type=template&id=462a089f"
import script from "./MyVCards.vue?vue&type=script&lang=js"
export * from "./MyVCards.vue?vue&type=script&lang=js"
import style0 from "./MyVCards.vue?vue&type=style&index=0&id=462a089f&prod&lang=css"
import style1 from "./MyVCards.vue?vue&type=style&index=1&id=462a089f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports